import * as t from 'io-ts'

export const Members = t.type({
  from7to20: t.number,
  from21to28: t.number,
  from29: t.number
})
export type Members = t.TypeOf<typeof Members>

export const Activity = t.union([
  t.literal('EARLY_YOUTH_ACTIVITIES'),
  t.literal('HOBBY_CLUBS'),
  t.literal('POLITICAL'),
  t.literal('SCOUT'),
  t.literal('SPIRITUAL'),
  t.literal('OTHER')
])
export type Activity = t.TypeOf<typeof Activity>

export const TargetGroup = t.union([
  t.literal('ALL'),
  t.literal('BOYS'),
  t.literal('GIRLS')
])
export type TargetGroup = t.TypeOf<typeof TargetGroup>

export const NuoraOrg = t.type({
  activity: Activity,
  targetGroup: TargetGroup,
  members: Members
})
export type NuoraOrg = t.TypeOf<typeof NuoraOrg>

export interface DraftNuoraOrg {
  targetGroup: TargetGroup | ''
  activity: Activity | ''
  members: Members
}
